import { InterviewForThisRoleValues } from '../api/role/models/CandidateConnectionDto'

interface InterviewForThisRolePillProps {
    value?: InterviewForThisRoleValues
}

function InterviewForThisRolePill({
    value,
}: InterviewForThisRolePillProps): React.JSX.Element {
    // Map values to display text and custom styles
    const displayMap: Record<
        InterviewForThisRoleValues | 'undefined', // Include 'undefined' as a key type
        { text: string; style: React.CSSProperties }
    > = {
        [InterviewForThisRoleValues.YES]: {
            text: 'Yes',
            style: {
                backgroundColor: '#2ECC71', // Soft green background
                color: 'white',
                padding: '5px 10px',
                borderRadius: '15px', // Rounded pill shape
                fontWeight: 'bold',
                textAlign: 'center',
                display: 'inline-block',
            },
        },
        [InterviewForThisRoleValues.NO]: {
            text: 'No',
            style: {
                backgroundColor: '#E74C3C', // Soft red background
                color: 'white',
                padding: '5px 10px',
                borderRadius: '15px', // Rounded pill shape
                fontWeight: 'bold',
                textAlign: 'center',
                display: 'inline-block',
            },
        },
        undefined: {
            text: '-',
            style: {
                backgroundColor: '#5D6D7E', // Neutral gray-blue background
                color: 'white',
                padding: '5px 10px',
                borderRadius: '15px', // Rounded pill shape
                fontWeight: 'bold',
                textAlign: 'center',
                display: 'inline-block',
            },
        },
    }

    // Use 'undefined' as the default key when value is undefined
    const { text, style } = displayMap[value ?? 'undefined']

    return <div style={style}>{text}</div>
}

export default InterviewForThisRolePill
